import { ConfigRepository } from '../repositories/ConfigRepository';
import { Config } from '../domain/entities/Config';
import { ConfigMappings } from '../domain/config-mappings';

export class ServiceStartedUseCase {
    constructor(
        // eslint-disable-next-line @typescript-eslint/no-parameter-properties
        private configRepository: ConfigRepository,
        // eslint-disable-next-line @typescript-eslint/no-parameter-properties
        private businessUnitId: string,
        // eslint-disable-next-line @typescript-eslint/no-parameter-properties
        private configs: Record<string, unknown>
    ) {}

    public execute = async () => {
        const configs = {
            ...this.configs,
            isCoreSite: this.businessUnitId.indexOf('corev1') !== -1
        };

        const ecommConfig = Config.fromJSON(configs);

        // load buid configs data
        await this.configRepository.loadConfigs(this.businessUnitId);
        // set ecomm config data
        this.configRepository.setEcommConfig(ecommConfig);
        // set mapping
        this.configRepository.setMapping(ConfigMappings);
    };
}
